// extracted by mini-css-extract-plugin
module.exports = {"testCoverWrapper":"testCover__testCoverWrapper___2t65Y"};